import './audio-custom.js';
import { sendCustomEvent } from '../../assets/js/utils.js';

class AudioPlayer extends HTMLElement {
    constructor() {
        super();
        this.totalCds = this.totalCdsLenght;
        this.close = this.querySelector('[data-control="close"]');
    }
    
    connectedCallback() {
        this.removeAttribute('no-js');
        this.addEvents();
    }

    setActiveAudio(oldValue) {
        if (this.activeAudio) this.activeAudio.setAttribute('data-state', 'inactive');
        if (oldValue !== undefined) {
            const newValue = this.isLastCd(oldValue) ? this.firstCd : oldValue + 1;
            this.nextCd = this.querySelector(`audio-custom[data-cd="${newValue}"]`);
            this.nextCd.setAttribute('data-state', 'active');
            return;
        }
        // Initialer Aufruf
        this.querySelector('audio-custom').setAttribute('data-state', 'active');
    }

    addEvents() {
        this.close.addEventListener('click', () => {
            this.closeAudioplayer();
            sendCustomEvent('audio-custom-pause');
        })

        document.addEventListener('audioplayer-oeffnen', () => {
            this.openAudioplayer();
            this.setActiveAudio();
            this.toggleFooterMargin();
            this.startFooterObserver();
        })

        document.addEventListener('audio-custom-cd-ended', (event) => {
            const { cd } = event.detail;
            this.setActiveAudio(cd);
        })
    }

    openAudioplayer() {
        this.setAttribute('open', '');
    }

    closeAudioplayer() {
        this.removeAttribute('open');
        this.observer.disconnect();
        this.removeAttribute('data-position');
        this.toggleFooterMargin();
    }

    startFooterObserver() {
        const options = {
            threshold: [0, 0.001, 0.002, 0.005]
        };
        this.observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                this.togglePosition(entry);
            }
        }, options);
        const target = document.querySelector('.footer-main');
        this.observer.observe(target);
    }

    togglePosition(entry) {
        const { target, intersectionRatio } = entry;
        if (intersectionRatio > 0) {
            const top = target.offsetTop - this.offsetHeight;
            this.style.top = `${top}px`;
            this.setAttribute('data-position', 'bottom');
        } else {
            this.removeAttribute('style');
            this.removeAttribute('data-position');
        }
    }

    toggleFooterMargin() {
        const footer = document.querySelector('.footer-main');
        if (getComputedStyle(footer).marginTop === '0px') {
            footer.style.marginTop = `${this.offsetHeight}px`;
            return;
        }
        footer.style.marginTop = 0;
    }

    isLastCd(oldValue) {
        if (this.firstCd === 0) {
            return oldValue === this.totalCdsLenght - 1;
        }
        return oldValue === this.totalCdsLenght; 
    }

    get activeAudio() {
        return this.querySelector('audio-custom[data-state="active"]');
    }

    get firstCd() {
        return parseInt(this.querySelector('audio-custom').dataset['cd']);
    }

    set totalCds(value) {
        this.dataset['totalCds'] = value;
    }

    get totalCdsLenght() {
        return this.querySelectorAll('audio-custom').length;
    }
}

if (!customElements.get("audio-player")) {
    customElements.define("audio-player", AudioPlayer);
}
